import * as types from './types';

const initialState = {
  planId: null, // pre-selected plan - used by pricing page
  subscriptionId: null, // actual subscription id
  subscriptionStatus: 'na',
  customerId: null,
  autorefresh: true,
  planInfo: null, // detailed plan information
  productInfo: null, // product information
  subscriptionInfo: null, // subscription details
  refreshIndex: 0 // used to trigger refreshing of billing data
};

const billingReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_BILLING:
      return {
        ...state,
        ...action.payload
      };
    case types.SET_PLAN_ID:
      return {
        ...state,
        planId: action.payload
      };
    case types.SET_SUBSCRIPTION_ID:
      return {
        ...state,
        subscriptionId: action.payload
      };
    case types.SET_SUBSCRIPTION_STATUS:
      return {
        ...state,
        subscriptionStatus: action.payload
      };
    case types.SET_PLAN_INFO:
      return {
        ...state,
        planInfo: action.payload
      };
    case types.SET_PRODUCT_INFO:
      return {
        ...state,
        productInfo: action.payload
      };
    case types.SET_SUBSCRIPTION_INFO:
      return {
        ...state,
        subscriptionInfo: action.payload
      };
    case types.REFRESH_BILLING:
      return {
        ...state,
        refreshIndex: state.refreshIndex + 1
      };
    default:
      return state;
  }
};

export default billingReducer; 